import { defineStore } from 'pinia'

export const useTasksStore = defineStore('tasks', {
  state: () => ({
    statusList: {},
    list: [],
    selectedItems: [],
    filter: {
      current: ['work', 'done'],
      backlog: ['plan'],
      archive: ['closed'],
    }
  }),
  actions: {
    setList(list) {
      this.list = list || []
    },
    setStatusList(statusList) {
      this.statusList = statusList
    }
  },
})
